// Verifica se dois objetos possuem as mesmas chaves
export function hasSameKeys(a, b) {
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  return JSON.stringify(aKeys) === JSON.stringify(bKeys);
}

// Verifica se o objeto possui alguma propriedade Vazia ou Nula
export function hasAnyKeyEmpty(obj) {
  var keys = Object.getOwnPropertyNames(obj);
  var result = false;

  keys.forEach(key => {
    
    if (obj[key] === null || obj[key] === "") {
      result = true;
    }
  });
  return result;
}

// Verifica se o objeto possui todas propriedades "true"
export function hasAllKeysTrue(obj) {
  var keys = Object.getOwnPropertyNames(obj);
  var result = true;

  keys.forEach(key => {
    
    if (obj[key] === false) {
      result = result && false;
    }
  });
  return result;
}

// Altera todos os valores do objeto para determinado valor(value)
export function setAllKeys(obj, value) {
  var keys = Object.getOwnPropertyNames(obj);

  obj = keys.map(key => {
    obj[key] = value;
    return true;
  });

  return obj;
}